import { Deserializable } from '../../protocols/deserializable';
import { MemberStatusType } from './member-status-type';
import { MemberStatusTypeEnum } from '../enum/member-status-type-enum';
import { EmploymentStatusType } from '../../employers/employer-history/types/employment-status-type';
import { EmploymentStatusTypeId } from '../../employers/enum/employment-status-type-id';
import { StatusPill } from '../../shared/status-pill';
import { MemberStatusUtils } from '../../../utils/member-status-utils';

export class EmployerMemberRecord implements Deserializable {
  public id!: number;
  public firstName!: string;
  public lastName!: string;
  public email!: string;
  public statusId!: MemberStatusTypeEnum;
  public status!: MemberStatusType;
  public employmentStatusId!: EmploymentStatusTypeId;
  public employmentStatus!: EmploymentStatusType;

  // Not From API
  public statusPill!: StatusPill;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.statusPill = MemberStatusUtils.statusPill(this.statusId);
    if (!!this.status) {
      this.status = Deserialize?.instanceOf(MemberStatusType, this.status);
    }
    if (!!this.employmentStatus) {
      this.employmentStatus = Deserialize?.instanceOf(EmploymentStatusType, this.employmentStatus);
    }
  }
}
